module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/changing-room-mobile-0bff43f903706d1972aa03488d39bac2.png";